import React, { useState } from 'react';

const DebugPanel = ({ apiEndpoint }) => {
  const [testContext, setTestContext] = useState('');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const testApi = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ context: testContext })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API returned status ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      setResponse(data);
      console.log('API response:', data);
    } catch (err) {
      setError(err.toString());
      console.error('API test error:', err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="card" style={{ marginTop: '2rem', textAlign: 'left' }}>
      <h2>API Debug Tool</h2>
      <p>Test the API endpoint: <code>{apiEndpoint}</code></p>
      
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
          Test Context:
        </label>
        <textarea 
          value={testContext}
          onChange={(e) => setTestContext(e.target.value)}
          style={{ width: '100%', minHeight: '100px' }}
          placeholder="Enter test context here (e.g., sample questions and answers)"
        />
      </div>
      
      <button 
        onClick={testApi}
        disabled={loading || !testContext.trim()}
        style={{ marginBottom: '1rem' }}
      >
        {loading ? 'Testing...' : 'Test API'}
      </button>
      
      {error && (
        <div style={{ 
          backgroundColor: 'rgba(255, 50, 50, 0.1)', 
          border: '1px solid rgba(255, 50, 50, 0.3)',
          borderRadius: '8px',
          padding: '1rem',
          marginTop: '1rem'
        }}>
          <h3 style={{ color: '#ff5555', marginTop: 0 }}>Error</h3>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{error}</pre>
        </div>
      )}
      
      {response && (
        <div style={{ 
          backgroundColor: 'rgba(50, 255, 50, 0.1)', 
          border: '1px solid rgba(50, 255, 50, 0.3)',
          borderRadius: '8px',
          padding: '1rem',
          marginTop: '1rem'
        }}>
          <h3 style={{ color: '#55aa55', marginTop: 0 }}>Success</h3>
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word',
            maxHeight: '300px',
            overflow: 'auto'
          }}>
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default DebugPanel;